import { createEffectHook, TypedEvent } from '@rehaje/core'

import type { ActionNode } from './TypedNode'

/**
 * ActionNode 被执行指定事件时触发
 */
export class ActionTriggerEvent extends TypedEvent<ActionNode> {
  type = 'onActionTrigger' as const
}

export const { onActionTrigger, onActionTriggerCapture } =
  createEffectHook(ActionTriggerEvent)

declare global {
  export interface RehajeTypedEvents {
    onActionTrigger: ActionTriggerEvent
  }
}
